import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FaPills } from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const EditObat = () => {
  const param = useParams();
  const flag = param["*"];
  const navigate = useNavigate();
  const [obatDetail, setObatDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDetailObat = async (param) => {
    const token = localStorage.getItem("token");
    let newParam = encodeURI(param);
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/drug/detail/${newParam}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (resp.status === 200) {
        setObatDetail(resp.data.data);
      } else {
        setError("Gagal mengambil data obat.");
      }
    } catch (err) {
      setError("Gagal mengambil data obat.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetailObat(flag);
  }, [flag]);

  const handleChange = (e) => {
    setObatDetail((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");
    if (!token) {
      setError("Token tidak ditemukan.");
      setLoading(false);
      return;
    }

    const payload = {
      name: obatDetail.name,
      dosis: obatDetail.dosis,
      isi: obatDetail.isi,
      harga_jual: parseFloat(obatDetail.harga_jual),
      harga_beli: parseFloat(obatDetail.harga_beli),
      produsen: obatDetail.produsen,
      description: obatDetail.desc,
    };

    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/v1/drug/${obatDetail.id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      alert("Obat berhasil diperbarui!");
      navigate("/obat-paket/obat");
    } catch (err) {
      console.error(err);
      setError("Gagal memperbarui obat.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-6 bg-gray-50 w-full min-w-0">
      <PageCreateHeader
        icon={FaPills}
        title="Edit Obat"
        description="Perbarui data obat di katalog"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Obat", to: "/obat-paket/obat" },
          { label: "Edit Obat" },
        ]}
      />

      <div className="w-full bg-white shadow-lg rounded-3xl p-8 border border-gray-100 min-w-0">
        {error && <p className="text-red-500 mb-4">{error}</p>}

        {loading ? (
          <p className="text-gray-600">Memuat data obat...</p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Nama Obat:
                </label>
                <input
                  type="text"
                  name="name"
                  value={obatDetail.name || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Dosis:
                </label>
                <input
                  type="text"
                  name="dosis"
                  value={obatDetail.dosis || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Harga Jual (Rp):
                </label>
                <input
                  type="number"
                  name="harga_jual"
                  value={obatDetail.harga_jual || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Harga Beli (Rp):
                </label>
                <input
                  type="number"
                  name="harga_beli"
                  value={obatDetail.harga_beli || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Produsen:
                </label>
                <input
                  type="text"
                  name="produsen"
                  value={obatDetail.produsen || ""}
                  onChange={handleChange}
                  required
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Deskripsi:
                </label>
                <input
                  type="text"
                  name="desc"
                  value={obatDetail.desc || ""}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Isi:
                </label>
                <input
                  type="text"
                  name="isi"
                  value={obatDetail.isi || ""}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-300 transition"
                />
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-yellow-500 text-white p-4 rounded-xl shadow-md hover:bg-yellow-600 hover:scale-105 transition transform font-semibold"
              disabled={loading}
            >
              {loading ? "Menyimpan..." : "Simpan Perubahan"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default EditObat;
